<template>
  <div class="mine-edit unselect poa">
    <div class="edit-more-false csp" @click="showEdit" v-show="!value"><i class="edit-more mine-ico"></i>批量编辑</div>
    <div class="edit-inner flex wsnw" v-show="value">
      <div class="all-select bsb tac csp" @click="editCb('all')">全部</div>
      <div class="del tac csp bsb" :class="{disabled: !selected}" @click="selected && editCb('del')">{{delText}}<span
              v-show="selected">({{selected}})</span></div>
      <div class="cancel tac csp bsb" @click="editCb('cancel')">取消</div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: Boolean,
        required: true,
      },
      selected: {
        type: Number,
        default: 0,
      },
      delText: {
        type: String,
        default: '删除',
      },
    },
    methods: {
      editCb(type) {
        switch (type) {
          case 'cancel':
            this.selected = [];
            this.value = false;
            this.$emit('input', false);
            break;
        }
        this.$emit(type);
        this.$emit('edit-callback', type);
      },
      showEdit() {
        this.value = true;
        this.$emit('input', true);
      },
    },
  }
</script>

<style scoped lang="less">
  .mine-edit {
    top: 35px;
    right: 18px;
    font-size: 14px;
    color: #959595;
    .edit-more-false {
      &:hover {
        color: #1177ff;
        .edit-more {
          &:after {
            background-color: #1177ff;
          }
        }
      }
    }
    .edit-inner {
      > :nth-child(n) {
        margin-left: 12px;
        padding: 0 6px;
        min-width: 50px;
        height: 24px;
        line-height: 24px;
        border: 1px solid #9B9B9B;
        border-radius: 4px;
        font-size: 13px;
        color: #666f7a;
        &:hover {
          border-color: #1177ff;
          color: #1177ff;
        }
      }
      .disabled {
        border-color: #d2d2d2 !important;
        color: #b5b5b5 !important;
        cursor: not-allowed;
      }
    }
  }
</style>